import useGetApi from 'src/api/useGetApi';
import { keepPreviousData } from '@tanstack/react-query';

export interface CustomerPreviewDTO {
  id: string;
  name: string;
  erpDisplayName?: string | null;
  aliases?: string[] | null;
  address?: string | null;
  phoneNumber?: string | null;
  emailDomain?: string | null;
  contactPerson?: string | null;
  paymentTerms?: string | null;
  creditLimit?: number | null;
  creditLimitCurrency?: string | null;
  isaId?: string | null;
  originMetadata?: Record<string, unknown>;
}

interface PageInfo {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

interface QueryParams {
  page?: number;
  pageSize?: number;
  search?: string;
  name?: string;
  /** "latinFirst" ranks Latin-letter names ahead of CJK/other scripts. */
  sort?: 'name' | 'latinFirst';
}

type ApiResponse = {
  edges: CustomerPreviewDTO[];
  pageInfo: PageInfo;
};

const useCustomers = (params?: QueryParams, enabled?: boolean) => {
  return useGetApi<ApiResponse>({
    endpoint: 'accounts-receivable/customers',
    queryParameters: params,
    options: {
      enabled,
      placeholderData: keepPreviousData,
    },
  });
};

export default useCustomers;
